import { showNotification } from "@/entities/notification"
import { userKeys } from "@/entities/user"
import { registerNotification } from "@/shared/api/websocket"

registerNotification("rank_change", {
	handle: ({ notification_id, data }, ctx) => {
		ctx.queryClient.invalidateQueries({
			queryKey: userKeys.byId(ctx.userId),
		})

		showNotification({
			type: "rank-change",
			placement: "home",
			changeType: data.change_type,
			toTier: data.rank.to.tier,
			pointsToNext: data.rank.to.points_to_next,
			notificationId: notification_id,
			origin: "server",
			name: "rank_change",
		})
	},
	route: () => ({ to: "/profile" }),
	routePopup: null,
})
